/**
* reducers for the news
*
* Created by Tom on 15/06/18
*/

import C from '../constants'

const initState = {
    nLoading: false,
    nData: []
}

export const newsState = (state = initState, action) => {

    switch(action.type) {

        // in case of `nLoading` change
        case C.SET_NEWS_LOADER:
            return {
                ...state,
                nLoading: action.payload
            }

        // in case of `nData` change
        case C.SET_NEWS_DATA:
            return {
                ...state,
                nData: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/newsReducers.js